import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import InputBase from '@material-ui/core/InputBase'
import IconButton from '@material-ui/core/IconButton'
import SearchIcon from '@material-ui/icons/Search'
import ClearIcon from '@material-ui/icons/Clear'
import { debounce } from '@engine/utils/jsUtils'
import { FilterProjects } from '@components/custom'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp'

const useStyles = makeStyles(theme => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 528,
    backgroundColor: '#F2F4F7',
    boxShadow: 'none'
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    // fontFamily: '\'Inter\', sans-serif'
    fontFamily: '\'DIN Pro Light\''
  },
  iconButton: {
    padding: 10,
    color: '#5E6C84'
  },
  divider: {
    height: 28,
    margin: 4
  }
}))

const AdvancedSearchInput = props => {
  const classes = useStyles()
  const searchText = useRef('')
  const [searchIconDisplay, setSearchIconDisplay] = useState(false)
  const [filterProjectsFlag, setFilterProjectsFlag] = useState(false)

  const toogleFilterProjectsDialog = () => {
    clearSearch()
    setFilterProjectsFlag(!filterProjectsFlag)
  }

  const clearSearch = () => {
    searchText.current.value = ''
    setSearchIconDisplay(false)
    props.setTotalProjectsText({ totalProjectsText: '' })
    props.setPagination({ 'queryParams': {}, offset: 0 })
    props.getAllProjects()
    props.setRecentPagination({ 'queryParams': {}, offset: 0 })
    props.getRecentProjects()
  }

  const handleChange = projectName => {
    if (projectName) {
      setSearchIconDisplay(true)
      props.setTotalProjectsText({ totalProjectsText: '' })
      props.setPagination({ 'queryParams': { projectName }, offset: 0 })
      props.searchProjects()
      props.setRecentPagination({ 'queryParams': { projectName }, offset: 0 })
      props.getRecentProjects()
    } else {
      setSearchIconDisplay(false)
      clearSearch()
    }
  }

  const filterChange = searchFields => {
    const { propertyName, city, owner, dealNumber } = searchFields
    // fetch city and owner guid by using the city and owner name
      setFilterProjectsFlag(false)
      props.setTotalProjectsText({ totalProjectsText: '' })
      props.setPagination({ 'queryParams': { propertyName, city, 'createdUserGuid': owner, dealNumber }, offset: 0 })
      props.searchProjects()
  }

  const debouncedChange = debounce(handleChange, 250)

  const disableEnterKeyInAdvanceSearch = e => {
    let key
    if (window.event) {
      key = window.event.keyCode
    } else {
      key = e.which
    }

    if (key === 13) {
      e.preventDefault()
    }
  }

  return (
    <>
    <Paper component="form" className={classes.root}>
      <IconButton className={classes.iconButton} aria-label="search">
        <SearchIcon />
      </IconButton>
      <InputBase
        className={classes.input}
        placeholder="Search for a comps project"
        inputProps={{ 'data-testid': 'search-comps-project' }}
        onChange={e => debouncedChange(e.target.value)}
        onKeyDown={e => disableEnterKeyInAdvanceSearch(e)}
        inputRef={searchText}
      />
      {filterProjectsFlag ?
        <IconButton data-testid="filter-icon" onClick={toogleFilterProjectsDialog} className={classes.iconButton} aria-label="advanced-options">
          <ArrowDropUpIcon />
        </IconButton>
        :
        <IconButton data-testid="filter-icon" onClick={toogleFilterProjectsDialog} className={classes.iconButton} aria-label="advanced-options">
          <ArrowDropDownIcon />
        </IconButton>
      }
       {searchIconDisplay && (
        <IconButton data-testid="search-icon" onClick={clearSearch} className={classes.iconButton} aria-label="advanced-options">
          <ClearIcon />
        </IconButton>
      )}
    </Paper>
    {filterProjectsFlag && <FilterProjects filterChange={filterChange} toogleFilterProjectsDialog={toogleFilterProjectsDialog}/>}
    </>
  )
}

AdvancedSearchInput.propTypes = {
  searchProjects: PropTypes.func,
  getAllProjects: PropTypes.func,
  setPagination: PropTypes.func,
  setRecentPagination: PropTypes.func,
  setTotalProjectsText: PropTypes.func,
  getRecentProjects: PropTypes.func
}

export default AdvancedSearchInput

